import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=3bb08153&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=ts"
export * from "./StatusIndicator.vue?vue&type=script&lang=ts"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=3bb08153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb08153",
  null
  
)

export default component.exports